let apiKey = "";
function setApiKey(newApiKey) {
  console.log("received api key:", newApiKey);
  apiKey = newApiKey;
}

async function fetchApi({ url, method = "GET", body, jsonResult = true, successCodes = [200] }) {
  const resource = process.env.REACT_APP_API_URL + url;
  const options = {
    method,
    headers: {
      "Content-Type": "application/json",
      "X-API-KEY": apiKey,
    },
    body: body === undefined ? undefined : JSON.stringify(body),
  };

  let res = await fetch(resource, options);
  if (!successCodes.includes(res.status)) {
    console.log(`error fetchApi ${method} ${url}:`, res);
    throw await res.json();
  } else {
    if (jsonResult) {
      res = await res.json();
    }
    return res;
  }
}

async function getDoorStates(vehicle_id) {
  return await fetchApi({
    url: "/vehicles/" + vehicle_id + "/doors/",
  });
}

async function getBoxStates(vehicle_id) {
  return await fetchApi({
    url: "/vehicles/" + vehicle_id + "/boxes/",
  });
}

async function getCompartmentStates(vehicle_id, box_idx) {
  return await fetchApi({
    url: "/vehicles/" + vehicle_id + "/boxes/" + box_idx + "/compartments/",
  });
}

async function moveDoor(vehicle_id, door_id, action) {
  return await fetchApi({
    url: "/vehicles/" + vehicle_id + "/doors/" + door_id + "?action=" + action,
    method: "POST",
    jsonResult: false,
  });
}

async function moveBox(vehicle_id, box_idx, action) {
  return await fetchApi({
    url: "/vehicles/" + vehicle_id + "/boxes/" + box_idx + "?action=" + action,
    method: "POST",
    jsonResult: false,
  });
}

async function moveCompartment(vehicle_id, box_idx, compartment_idx, action) {
  return await fetchApi({
    url:
      "/vehicles/" +
      vehicle_id +
      "/boxes/" +
      box_idx +
      "/compartments/" +
      compartment_idx +
      "?action=" +
      action,
    method: "POST",
    jsonResult: false,
  });
}

async function getVehicleOverview(vehicle_id) {
  return await fetchApi({
    url: "/vehicles/" + vehicle_id + "/overview",
  });
}

async function getAllocations(vehicle_id) {
  return await fetchApi({
    url: "/vehicles/" + vehicle_id + "/allocations",
  });
}

async function setDoorsAndCompartments(vehicle_id, allocation_id, action) {
  return await fetchApi({
    url:
      "/vehicles/" +
      vehicle_id +
      "/allocations/" +
      allocation_id +
      "?action=" +
      action +
      "&evenIfDone=true",
    method: "POST",
    jsonResult: false,
  });
}

async function setAllocationDone(vehicle_id, allocation_id) {
  return await fetchApi({
    url: "/vehicles/" + vehicle_id + "/allocations/" + allocation_id + "/done",
    method: "POST",
    jsonResult: false,
  });
}

export {
  setApiKey,
  getDoorStates,
  getBoxStates,
  getCompartmentStates,
  moveDoor,
  moveBox,
  moveCompartment,
  getVehicleOverview,
  getAllocations,
  setDoorsAndCompartments,
  setAllocationDone,
};
